/**
 * @deprecated This file is deprecated. Use @starjack/utils instead.
 */

import { convertDateFromDateArray } from '@/utils/time';

/**
 * @deprecated Use FrontendType from @starjack/utils instead.
 */
export type FrontendType = 'frontendType';

/**
 * @deprecated Use BackendType from @starjack/utils instead.
 */
export type BackendType = 'backendType';

/**
 * @deprecated Use ObjectType from @starjack/utils instead.
 */
export type ObjectType = BackendType | FrontendType;

/**
 * @deprecated Use StarjackDate from @starjack/utils instead.
 */
export type StarjackDate<T extends ObjectType = FrontendType> =
    T extends FrontendType ? Date : number[];

/**
 * @deprecated Use StarjackDateISO from @starjack/utils instead.
 */
export type StarjackDateISO<T extends ObjectType = FrontendType> =
    T extends FrontendType ? Date : string;

/**
 * @deprecated Use convertIsoDateStringToDate from @starjack/utils instead.
 */
export const convertIsoDateStringToDate = (isoDate: string): Date => {
    if (!isoDate) return null;

    return new Date(isoDate);
};

/**
 * @deprecated Use multiLangStringOptions from @starjack/utils instead.
 */
export const multiLangStringOptions = ['de', 'en'] as const;

/**
 * @deprecated Use MultiLangStringOption from @starjack/utils instead.
 */
export type MultiLangStringOption = (typeof multiLangStringOptions)[number];

/**
 * @deprecated Use MultiLangString from @starjack/utils instead.
 */
export type MultiLangString = Record<MultiLangStringOption, string>;

/**
 * @deprecated Use Language from @starjack/utils instead.
 */
export enum Language {
    DE = 'DE',
    EN = 'EN',
}

/**
 * @deprecated Use DateRange from @starjack/utils instead.
 */
export type DateRange = [Date?, Date?];

/**
 * @deprecated Use StarjackDateRange from @starjack/utils instead.
 */
export type StarjackDateRange<T extends ObjectType = FrontendType> = {
    from: StarjackDate<T>;
    to: StarjackDate<T>;
};

/**
 * @deprecated Use convertStarjackDateRangeToFrontend from @starjack/utils time instead.
 */
export const convertStarjackDateRangeToFrontend = (
    dateRange: StarjackDateRange<BackendType>
): StarjackDateRange => ({
    from: convertDateFromDateArray(dateRange.from),
    to: convertDateFromDateArray(dateRange.to),
});

/**
 * @deprecated Use Gender from @starjack/utils instead.
 */
export enum Gender {
    MALE = 'MALE',
    FEMALE = 'FEMALE',
}
